(function ($) {
  Drupal.behaviors.faqTemplate = {
    attached: false,
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;

      var $templates = $('.js-faq-template', context);

      $templates.each(function () {
        var $template = $(this);
        var $trigger = $('.js-faq-toggle', $template);
        var $cta = $('a.button', $trigger);

        if ($cta.length > 0 && $cta.first().attr('href') === '#') {
          $trigger.removeClass('collapsible-block__trigger');
          $trigger = $cta.first();
        }

        // Check if this has a trigger
        if ($trigger.length > 0) {
          // Toggle the nav
          $trigger.once().on('click', function (e) {
            var $toggleContainer = $(this).closest('.js-faq-toggle');
            var $parent = $toggleContainer.parent();
            var isFormatter = $toggleContainer.hasClass('faq-formatter__toggle');
            var $content = isFormatter ? $parent.next('.js-faq-content') : $toggleContainer.next('.js-faq-content');
            var $targetLink = $(e.target).closest('a');
            // Cast the expanded state as a boolean
            var expanded = $parent.attr('aria-expanded') !== 'false';

            // Prevent page jumps if the target is a link and if its href is just a hash (#)
            if ($targetLink.length > 0 && $targetLink.attr('href') === '#') {
              e.preventDefault();
            }

            // Switch the states of aria-expanded and aria-hidden
            $parent.attr('aria-expanded', !expanded);
            $content.attr('aria-hidden', expanded);
          });
        }
      });
    }
  };
})(jQuery);
